import { Component } from '@angular/core';
import { DocumentDurationWidget } from './components/docdurationwidget';
import { StatsWidget } from './components/statswidget';
import { CustomersActivityWidget } from './components/customersactivitywidget';
import { JournalMoveDistWidget } from './components/jornalmovedistwidget';
import { FileProcessedWidget } from './components/fileprocessedwidget';

@Component({
    selector: 'app-dashboard',
    imports: [StatsWidget, CustomersActivityWidget, JournalMoveDistWidget, FileProcessedWidget, DocumentDurationWidget],
    template: `
        <div class="grid grid-cols-12 gap-8">
            <app-stats-widget class="contents" />
            <div class="col-span-12 xl:col-span-6 min-w-0">
                <app-customer-activity-widget />
            </div>
            <div class="col-span-12 xl:col-span-6 min-w-0">
                <app-file-processed-widget />
                <app-journal-movedist-widget />
                <app-doc-duration-widget />              
            </div>
        </div>
    `
})
export class Dashboard { }
